import { ReviewEntriesFilterType } from '../enums/reviewEntriesFilterType'

export const FILTER_TYPE_ORDER: ReviewEntriesFilterType[] = [
  ReviewEntriesFilterType.Supplier,
  ReviewEntriesFilterType.Account,
  ReviewEntriesFilterType.ExclVat,
  ReviewEntriesFilterType.VatRate,
  ReviewEntriesFilterType.InclVat,
]

type FilterTypeMeta = {
  labelKey: string
}

export const FILTER_TYPE_META: Record<ReviewEntriesFilterType, FilterTypeMeta> = {
  [ReviewEntriesFilterType.Supplier]: {
    labelKey: 'review_entries.table.column.supplier',
  },
  [ReviewEntriesFilterType.Account]: {
    labelKey: 'review_entries.table.column.account',
  },
  [ReviewEntriesFilterType.ExclVat]: {
    labelKey: 'review_entries.table.column.excl_vat',
  },
  [ReviewEntriesFilterType.VatRate]: {
    labelKey: 'review_entries.filters.vat_rate.label',
  },
  [ReviewEntriesFilterType.InclVat]: {
    labelKey: 'review_entries.table.column.incl_vat',
  },
}
